/**
 * @fileoverview Agent definition for character-details-ideation-v2.
 *
 * This agent generates three high-level summary concepts for a character
 * based on their name and story context.
 *
 * @category entities.characters.creation
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

// =============================================================================
// AGENT DEFINITION
// =============================================================================

export const definition: AppAgentDefinition = {
  id: 'character-details-ideation-v2',
  kind: 'primitive',
  name: 'Character Detail Ideation',
  description: 'Generates three high-level summary concepts for a character based on their name and story context.',
  category: 'characters',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,

  // --- Metadata (Hybrid Architecture) ---
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2024-06',
    lastUpdated: '2026-01',
    taxonomyPath: 'entities.characters.creation',
    usedBy: [
      'use-character-details-v2.ts',
    ],
    usedInComposites: [],
    relatedAgents: [
      'character-details-multimodal-generator-v3',
      'character-ideation-v2',
    ],
  },
};
